import React, {useMemo, useState} from "react";
import {CAlert, CButton, CForm} from "@coreui/react";
import {connect} from "react-redux";
import GridLayout from "react-grid-layout";
import { Responsive, WidthProvider} from "react-grid-layout";
import StoreCornerListWhere from "../../where/StoreCornerListWhere";
import {getFloorList} from "../../../../api/api";
import {Loading} from "../../../../components/common";
import Table from "./Table";

// const ResponsiveGridLayout = WidthProvider(Responsive);

const TableList = (props) => {
	const containerStyle = useMemo(() => ({width: '100%', height: '100%'}), []);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState({visible: false, message: ""});
	const [rowData, setRowData] = useState([]);
	const [floorList, setFloorList] = useState([]);
	const [tableList, setTableList] = useState([]);
	const [layout, setLayout] = useState({
		currentBreakPoint: "lg", compactType: "", mounted: true
	})
	const [searchForm, setSearchForm] = useState({
		cmpCd: "", brandCd: "", storeCd: "", cornerCd: ""
	});

	const handleSelect = (code, value) => {
		if (value === "C") {
			setSearchForm((state) => ({
				...state,
				cmpCd: code, brandCd: "", storeCd: "", cornerCd: ""
			}));
		} else if (value === "B") {
			setSearchForm((state) => ({
				...state,
				cmpCd: state.cmpCd, brandCd: code, storeCd: "", cornerCd: ""
			}));
		} else if (value === "S") {
			setSearchForm((state) => ({
				...state,
				cmpCd: state.cmpCd, brandCd: state.brandCd, storeCd: code, cornerCd: ""
			}));
		} else if (value === "O") {
			setSearchForm((state) => ({
				...state,
				cmpCd: state.cmpCd, brandCd: state.brandCd, storeCd: state.storeCd, cornerCd: code
			}));
		}
	}

	const save = () => {

	}

	const search = () => {
		setError({
			visible: false, message: ""
		});

		const {cmpCd, brandCd, storeCd} = props.selected;
		if (storeCd.length === 0) {
			setError({
				visible: true, message: "매장은 필수로 선택하셔야 합니다."
			});
			return;
		}

		setLoading(true);
		getFloorList(storeCd).then((result) => {
			const { responseBody, responseCode, responseMessage } = result.data;
			if (responseCode === "200") {
				// 성공
				setLoading(false);
				setFloorList(responseBody)
				console.log("response :: ", responseBody);
				setTableList(responseBody[0].tableInfos);
			}
		})
	}

	return (
		<div style={containerStyle}>
			{loading ? <Loading/> : null}
			{error.visible ? <CAlert color="danger">{error.message}</CAlert> : null}
			<div className="d-grid d-md-flex justify-content-between" style={{marginBottom: 10}}>
				<h5>테이블 관리</h5>
				<div className={"d-grid d-md-flex gap-1"}>
					<CButton size={"sm"} color="primary" onClick={save}>저장</CButton>
					<CButton size={"sm"} color="primary" onClick={search}>조회</CButton>
				</div>
			</div>

			<CForm className={"row row-cols-lg-auto g-1 align-items-center"}>
				<StoreCornerListWhere type={"S"} account={props.account} selected={searchForm} onSelect={(c, v) => handleSelect(c, v)}/>
			</CForm>

			<GridLayout className={"layout"}
								  width={1024}
						cols={5}
								  rowHeight={10}
								  onLayoutChange={(layout) => {중
								  	console.log("### layout change :: ", layout)
								  }}
								  measureBeforeMount={true}
								  useCSSTransforms={false}
								  compactType={layout.compactType}
								  preventCollision={!layout.compactType}
			>
				{tableList.length > 0 && tableList.map((item, idx) => {
					console.log("### item :: ", item);
					return <CButton key={String(item.seq)}
									data-grid={{
										x: item.tableLeft / 40,
										y: item.tableTop / 40,
										w: item.tableWidth / 40,
										h: item.tableHeight / 40}}>{item.tableNm}</CButton>
				})}
			</GridLayout>
		</div>
	)
}

const mapStateToProps = (state) => {
	const {account, store, selected, printer} = state;
	return {
		account, store, selected, printer
	}
}

export default connect(mapStateToProps, null)(TableList);
